module.exports = __webpack_public_path__ + "874a1a9da4502b501bd14fff2f725574.MP3";